module.exports = __webpack_public_path__ + "img/diamonds3_2.3742ceb5.png";